import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, createContext, useContext } from 'react'

const LaunchpadModalContext = createContext<RefObject<BottomSheetModalMethods> | null>(null)

type LaunchpadModalProviderProps = {
  launchpadModalRef: RefObject<BottomSheetModalMethods>
  children: React.ReactNode
}

const LaunchpadModalProvider = ({ launchpadModalRef, children }: LaunchpadModalProviderProps) => {
  return (
    <LaunchpadModalContext.Provider value={launchpadModalRef}>
      {children}
    </LaunchpadModalContext.Provider>
  )
}

const useLaunchpadModal = () => {
  return useContext(LaunchpadModalContext)
}

export { LaunchpadModalProvider, useLaunchpadModal }
